class VwKurumbonustanimtestveriDTO {
    id: number = 0;
    fkBonustanimdetayId?: number = null;
    fkTestDetaybilgiId?: number = null;
    veriAralikBaslangic?: number = null;
    veriAralikBitis?: number = null;
    ekleyenKullanici?: number = null;
    eklemeTarih?: string = null;
    guncelleyenKullanici?: number = null;
    guncellemeTarihi?: string = null;
    iptalTarihi?: string = null;
    iptalKullanici?: number = null;
    iptalNedenId?: number = null;
    iptalAciklama?: string = "";
    kurumAdi?: string = "";
    tanimDetayIslemAdi?: string = "";
    testDetaybilgiIslemAdi?: string = "";
    aciklama?: string = "";
    testDetaybilgiaktif?: string = "";
    zorunlu?: string = "";
    sira?: number = null;
    lishesap?: string = "";
    minimumdeger?: number = null;
    maksimumdeger?: number = null;
};
export default VwKurumbonustanimtestveriDTO;